import { mono } from './tokens';

export default function TagList({ tags, color }) {
  if (!tags || tags.length === 0) return null;
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {tags.map((tag) => (
        <span
          key={tag}
          style={{
            ...mono,
            fontSize: 9,
            color: color || 'rgba(255,255,255,0.6)',
            background: color ? `${color}14` : 'rgba(255,255,255,0.05)',
            border: `1px solid ${color ? `${color}33` : 'rgba(255,255,255,0.08)'}`,
            borderRadius: 12,
            padding: '2px 8px',
            textTransform: 'lowercase',
            letterSpacing: '0.02em',
          }}
        >
          {tag}
        </span>
      ))}
    </div>
  );
}
